import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type FormattedUpdate = {
  field: string
  newValue?: string | number | null
  oldValue?: string | number | null
}

type CardRowProps = {
  update: FormattedUpdate
}

const formatValue = (value: string | number | Date | null | undefined) => {
  return value?.toString() || ''
}

const NonDetailedField = ({ update }: CardRowProps) => {
  return (
    <>
      <Box flexDirection="row" gap="s8" paddingTop="s8">
        <Text size="200">{update.field}:</Text>
        <Text size="200" weight="bold">
          {i18n.t('contract_versions.approval_page.promotion.card_info.changed')}
        </Text>
      </Box>
    </>
  )
}

const RegularDetailedField = ({ update }: CardRowProps) => {
  const before = formatValue(update.oldValue)
  const after = formatValue(update.newValue)

  return (
    <>
      <Text size="200">{update.field}</Text>
      <Box
        flexDirection="row"
        gap="s12"
        borderRadius={{ all: 'abs008' }}
        background="grey100"
        border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
      >
        <Box
          border={{ right: { width: 's1', style: 'solid', color: 'grey400' } }}
          padding="s12"
          style={{ width: '50%' }}
        >
          <Text.Normal color="grey600">{before}</Text.Normal>
        </Box>
        <Box flexDirection="row" alignItems="center" padding="s12" style={{ width: '50%' }}>
          <Icon.Small icon="arrow-right" color="grey700" /> {after}
        </Box>
      </Box>
    </>
  )
}

const RemovedAdditionalCompensation = ({ update }: CardRowProps) => {
  const value = formatValue(update.oldValue)

  return (
    <>
      <Text size="200">{update.field}</Text>
      <Box
        flexDirection="row"
        gap="s12"
        borderRadius={{ all: 'abs008' }}
        background="grey100"
        border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
      >
        <Box padding="s12" flexDirection="row" alignItems="center">
          {value}
        </Box>
      </Box>
    </>
  )
}

const NewAdditionalCompensation = ({ update }: CardRowProps) => {
  const value = formatValue(update.newValue)

  return (
    <>
      <Text size="200">{update.field}</Text>
      <Box
        flexDirection="row"
        gap="s12"
        borderRadius={{ all: 'abs008' }}
        background="grey100"
        border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
      >
        <Box padding="s12" flexDirection="row" alignItems="center">
          {value}
        </Box>
      </Box>
    </>
  )
}

const CardRow = ({ update }: CardRowProps) => {
  const isNewAdditionalCompensation = update.field === 'new_additional_compensation'
  const isDeleteAdditionalCompensation = update.field === 'deleted_additional_compensation'
  const isAdditionalCompensationChange =
    isNewAdditionalCompensation || isDeleteAdditionalCompensation
  const isDetailedChange = !isAdditionalCompensationChange && (update.newValue || update.oldValue)
  const isNonDetailedChange = !isAdditionalCompensationChange && !isDetailedChange

  return (
    <Box gap="s8">
      {isNewAdditionalCompensation && <NewAdditionalCompensation update={update} />}
      {isDeleteAdditionalCompensation && <RemovedAdditionalCompensation update={update} />}
      {isDetailedChange && <RegularDetailedField update={update} />}
      {isNonDetailedChange && <NonDetailedField update={update} />}
    </Box>
  )
}

export default CardRow
